export function resolveTransmission(fuelTypeId: string): string {
    const transmission: {} = {
        "M": "Manual",
        "A": "Automatic",
        "SA": "Semi-auto",
        "CVT": "CVT"
    };

    return transmission[fuelTypeId];
}

export function resolveFuelType(fuelTypeId: string): string {
    const fuelType: {} = {
        "P": "Petrol",
        "D": "Diesel",
        "H": "Hybrid",
        "E": "Electric"
    };

    return fuelType[fuelTypeId];
}

export function resolveClaimType(claimTypeId: string): string {
    const claimType: {} = {
        "1": "Accident - you hit somebody/something",
        "2": "Accident - you/somebody hit each other",
        "3": "Accident - somebody/something hit you",
        "4": "Windscreen/Window glass",
        "5": "Malicious damage/Vandalism",
        "6": "Theft of vehicle",
        "7": "Theft from vehicle",
        "8": "Fire",
        "9": "Storm/Flood/Weather damage"
    };

    return claimType[claimTypeId];
}



// WEBPACK FOOTER //
// ./src/utils/resolveLookupValues.ts